/**
 * 中继apiapi
 * date:2022 05 13
 */
import httpRequest from '@/utils/request.js'
import qs from 'qs'

/** 中继列表接口 */
export const relayList = (params = {}, way) =>
  httpRequest.httpGet({
    url: '/service/relay/lst/' + way,
    params: {
      ...params
    }
  })
/** 获取中继网络参数详细配置接口 */
export const relayGetNetConfig = (params = {}) =>
  httpRequest.httpGet({
    url: '/service/relay/getNetConfig',
    params: {
      ...params
    }
  })
/** 新增中继信息接口 */
export const relayAddRelay = data =>
  httpRequest.httpPost('/service/relay/addRelay', data)
/** 编辑中继信息接口 */
export const relayEditRelay = data =>
  httpRequest.httpPost('/service/relay/editRelay', data)
/** 中继 停止使用、复用接口 */
export const relayEdit = (data, way) =>
  httpRequest.httpPost('/service/relay/edit/' + way, data)
/** 更新中继基本信息接口 */
export const relayUpdateRelay = data =>
  httpRequest.httpPost('/service/relay/updateRelay', data)
/** 更新中继网络参数接口 */
export const relayUpdateNetConfig = data =>
  httpRequest.httpPost('/service/relay/updateNetConfig', data)
/** 删除中继信息接口 */
export const relayDel = data =>
  httpRequest.httpdelete('/service/relay/del', data)
/** 获取中继详细信息接口 */
export const relayDetailInfo = id =>
  httpRequest.httpGet({
    url: '/service/relay/getRelayDetailInfo/' + id
  })
// 中继导入数据
export const importRelay = data =>
  httpRequest.httpPost('/service/relay/importRelay', data)

/**
 * 更新中继客户
 */
export const updateCustomer = data =>
  httpRequest.httpPost('/service/relay/update/customer', qs.stringify(data))
